import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const USER_GROUP_DELETED = gql`
  subscription userGroupDeleted {
    userGroupDeleted {
      userGroupId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
